module.exports = __webpack_public_path__ + "img/pic1.081696fe.png";